import {
  Text,
  Section,
  Row,
  Column,
  Img,
  Link,
  Container,
} from '@react-email/components';
import { KYDEventSummary } from '../../interfaces/KYDEvent';

const SimilarEvents = ({
  campaign_id,
  events,
  source,
}: {
  campaign_id?: string;
  events?: KYDEventSummary[];
  source?: string;
}) => {
  if (!events || events.length === 0) {
    return null;
  }

  return (
    <Section style={styles.section}>
      <Text style={styles.title}>Similar Events For You</Text>

      {/* Mobile View - One card per row */}
      <div className="mobile-only">
        {events.map((event, index) => (
          <Row
            key={`mobile-${index}`}
            style={{
              marginBottom: '14px',
              boxShadow:
                index % 2 === 0
                  ? '0px 15px 20px 0px rgba(0, 0, 0, 0.10)'
                  : undefined,
            }}
          >
            <Column
              style={{
                width: '100%',
                backgroundColor: index % 2 === 0 ? '#888888' : '#ffffff',
                padding: '12px',
                ...styles.card,
              }}
            >
              <Row>
                <Column
                  style={{
                    width: '40%',
                    paddingRight: '10px',
                    verticalAlign: 'top',
                  }}
                >
                  <Img
                    src={event.image}
                    alt={event.name}
                    style={{
                      width: '100%',
                      ...styles.image,
                    }}
                  />
                </Column>
                <Column
                  style={{
                    width: '60%',
                    verticalAlign: 'top',
                    paddingTop: '3px',
                  }}
                >
                  <div style={{ height: 'calc(100% - 50px)' }}>
                    <Text
                      style={{
                        fontSize: '12px',
                        margin: '0 0 12px 0',
                        fontWeight: '600',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: index % 2 === 0 ? '#ffffffE6' : '#000000',
                        lineHeight: '120%',
                        ...styles.text,
                      }}
                    >
                      {event.name}
                    </Text>
                    <Text
                      style={{
                        fontSize: '12px',
                        margin: '0 0 12px 0',
                        fontWeight: '600',
                        color: index % 2 === 0 ? '#ffffffE6' : '#000000',
                        ...styles.text,
                      }}
                    >
                      {event.display_start_at}
                    </Text>
                    <Text
                      style={{
                        fontSize: '10px',
                        margin: '0 0 0 0',
                        fontWeight: '400',
                        color: index % 2 === 0 ? '#ffffffE6' : '#000000',
                        ...styles.text,
                      }}
                    >
                      {event.venue?.name}
                    </Text>
                    <Text
                      style={{
                        fontSize: '10px',
                        margin: '0 0 6px 0',
                        fontWeight: '400',
                        color:
                          index % 2 === 0
                            ? '#ffffffE6 !important'
                            : '#000000 !important',
                        textDecoration: 'none',
                        ...styles.text,
                      }}
                    >
                      {event.venue?.city}, {event.venue?.state}
                    </Text>
                  </div>
                  <Link
                    href={
                      event.link +
                      `?utm_campaign=${campaign_id}&utm_source=kyd&utm_medium=email&utm_id=${campaign_id}`
                    }
                    style={{
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#343434',
                      color: index % 2 === 0 ? '#000000' : '#ffffff',
                      padding: '10px',
                      width: 'calc(100% - 24px)',
                      ...styles.button,
                    }}
                  >
                    Buy Tickets
                  </Link>
                </Column>
              </Row>
            </Column>
          </Row>
        ))}
      </div>

      {/* Desktop View - Two cards per row */}
      <div className="desktop-only">
        {Array.from({ length: Math.ceil(events.length / 2) }).map(
          (_, rowIndex) => (
            <Row
              key={`desktop-row-${rowIndex}`}
              style={{ marginBottom: '12px' }}
            >
              {events
                .slice(rowIndex * 2, rowIndex * 2 + 2)
                .map((event, colIndex) => {
                  const eventIndex = rowIndex * 2 + colIndex;
                  const isLastAndOdd =
                    events.length % 2 === 1 && eventIndex === events.length - 1;
                  return (
                    <Column
                      key={`desktop-col-${rowIndex}-${colIndex}`}
                      style={{
                        width: '50%',
                        padding: colIndex === 0 ? '0 6px 0 0' : '0 0 0 6px',
                      }}
                    >
                      <Container
                        style={{
                          width: !isLastAndOdd ? '100%' : '50%',
                          padding: '12px',
                          backgroundColor:
                            eventIndex % 2 === 0 ? '#888888' : '#ffffff',
                          ...styles.card,
                        }}
                      >
                        <Img
                          src={event.image}
                          alt={event.name}
                          style={{
                            width: '60%',
                            marginBottom: '10px',
                            display: 'block',
                            margin: '0 auto',
                            boxShadow: '0px 15px 10px 0px rgba(0, 0, 0, 0.15)',
                            ...styles.image,
                          }}
                        />
                        <Text
                          style={{
                            minHeight: '40px',
                            fontSize: '14px',
                            margin: '12px 0 12px 0',
                            fontWeight: '600',
                            color:
                              eventIndex % 2 === 0 ? '#ffffffE6' : '#000000',
                            textAlign: 'center',
                            lineHeight: '120%',
                            ...styles.text,
                          }}
                        >
                          {event.name}
                        </Text>
                        <Text
                          style={{
                            fontSize: '12px',
                            margin: '0 0 0px 0',
                            fontWeight: '600',
                            color:
                              eventIndex % 2 === 0 ? '#ffffffE6' : '#000000',
                            textAlign: 'center',
                            ...styles.text,
                          }}
                        >
                          {event.display_start_at}
                        </Text>
                        <Text
                          style={{
                            fontSize: '12px',
                            margin: '0 0 0 0',
                            fontWeight: '400',
                            color:
                              eventIndex % 2 === 0 ? '#ffffffE6' : '#000000',
                            textAlign: 'center',
                            ...styles.text,
                          }}
                        >
                          {event.venue?.name}
                        </Text>
                        <Text
                          style={{
                            fontSize: '12px',
                            minHeight: '40px',
                            margin: '0 0 6px 0',
                            textAlign: 'center',
                            color:
                              eventIndex % 2 === 0 ? '#ffffffE6' : '#000000',
                            ...styles.text,
                          }}
                        >
                          {event.venue?.address}
                        </Text>
                        <Link
                          href={
                            event.link +
                            `?utm_campaign=${campaign_id}&utm_source=kyd&utm_medium=email&utm_id=${campaign_id}`
                          }
                          style={{
                            backgroundColor:
                              eventIndex % 2 === 0 ? '#ffffff' : '#343434',
                            color: eventIndex % 2 === 0 ? '#000000' : '#ffffff',
                            padding: '12px',
                            width: 'calc(100% - 24px)',
                            boxShadow: '0px 15px 10px 0px rgba(0, 0, 0, 0.10)',
                            ...styles.button,
                          }}
                        >
                          Buy Tickets
                        </Link>
                      </Container>
                    </Column>
                  );
                })}
            </Row>
          ),
        )}
      </div>
    </Section>
  );
};
// Common styles
const styles = {
  section: {
    maxWidth: '600px',
    margin: '0 auto',
    marginTop: '20px',
  },
  title: {
    textAlign: 'center' as const,
    fontSize: '20px',
    fontWeight: '400',
    marginBottom: '15px',
    letterSpacing: '-0.6px',
    fontFamily: 'Helvetica, sans-serif',
  },
  card: {
    border: '1px solid rgba(0, 0, 0, 0.10)',
    borderRadius: '8px',
    boxShadow: '0px 15px 20px -4px rgba(0, 0, 0, 0.10)',
    overflow: 'hidden',
  },
  image: {
    borderRadius: '8px',
    aspectRatio: '1/1',
    boxShadow: '0px 15px 10px 0px rgba(0, 0, 0, 0.05)',
  },
  text: {
    fontFamily: 'Inter, sans-serif',
    lineHeight: '140%',
  },
  button: {
    borderRadius: '8px',
    display: 'block',
    fontSize: '12px',
    fontWeight: '600',
    textDecoration: 'none',
    fontFamily: 'Inter, sans-serif',
    textAlign: 'center' as const,
    boxShadow: '0px 15px 10px 0px rgba(0, 0, 0, 0.05)',
  },
};

export default SimilarEvents;
